import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';
import SubPage from 'uikit/SubPage';

import styles from './StudentErrors.module.scss';

const cx = classNames.bind(styles);

const StudentErrors = ({
  course,
  currentAnswer,
  handleAnswerNext,
  handleAnswerPrevious,
  handleClose,
  isVisible,
  nAnswers,
  question,
  versoComponent: VersoQuestion,
  t,
}) => (
  <SubPage
    isOpen={isVisible}
    onExit={handleClose}
    subtitle={course.title}
    title={t('Course/Teacher/Editor/StudentErrors/title')}
  >
    <div className={cx('subpage')}>
      <div className={cx('buttons')}>
        <Button
          icon="chevron-left"
          intent="white"
          isDisabled={currentAnswer <= 0}
          onClick={handleAnswerPrevious}
          size="large"
          tooltip={t('Course/Teacher/Editor/StudentErrors/previous-answer')}
        />
        <Button
          icon="chevron-right"
          intent="white"
          isDisabled={currentAnswer >= nAnswers - 1}
          onClick={handleAnswerNext}
          size="large"
          tooltip={t('Course/Teacher/Editor/StudentErrors/next-answer')}
        />
      </div>
      {question && question.result ? (
        <>
          <p className={cx('explanation-preview')}>
            {t('Course/Teacher/Editor/StudentErrors/explanation-preview')}
          </p>
          <VersoQuestion isDisabled question={question} />
        </>
      ) : (
        <p className={cx('no-wrong-answer')}>
          {t('Course/Teacher/Editor/StudentErrors/no-wrong-answer')}
        </p>
      )}
    </div>
  </SubPage>
);

StudentErrors.propTypes = {
  course: PropTypes.object.isRequired,
  currentAnswer: PropTypes.number.isRequired,
  handleAnswerNext: PropTypes.func.isRequired,
  handleAnswerPrevious: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  nAnswers: PropTypes.number.isRequired,
  question: PropTypes.object,
  versoComponent: PropTypes.elementType,
  t: PropTypes.func.isRequired,
};

StudentErrors.defaultProps = {
  question: undefined,
  versoComponent: undefined,
};

export default StudentErrors;
